import React, { useEffect } from 'react';
import { useIntl } from 'react-intl';
import CustomBtn from '../../../../../../generic/CustomBtn';
import './Disclaimer.scss';

const Disclaimer = ({ closeHandler }) => {
  const translate = useIntl();

  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, []);

  return (
    <div className="disclaimer-popup__wrapper">
      <div className="disclaimer-popup">
        <div className="disclaimer-popup__close-button-wrapper">
          <CustomBtn
            handleClick={() => closeHandler()}
            customClass="disclaimer-popup__close-button"
            iconClass="icon-close"
          />
        </div>
        <h3 className="disclaimer-popup__title">{translate.formatMessage({ id: 'carbon.disclaimer.legalDisclaimer' })}</h3>
        <ul className="disclaimer-popup__list" aria-label={translate.formatMessage({ id: 'carbon.disclaimer.pleaseRead' })}>
          <li>{translate.formatMessage({ id: 'carbon.disclaimer.createdForCollectingInformation' })}</li>
          <li>{translate.formatMessage({ id: 'carbon.disclaimer.nothingConstitutesAnInvitation' })}</li>
          <li>{translate.formatMessage({ id: 'carbon.disclaimer.someOfTheStatements' })}</li>
          <li>{translate.formatMessage({ id: 'carbon.disclaimer.neitherTheOFPProject' })}</li>
        </ul>
      </div>
    </div>
  );
};

export default Disclaimer;
